(function () {
  function init(root) {
    if (!root || root.dataset.huntingLookReady === 'true') return;
    root.dataset.huntingLookReady = 'true';

    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-look-filter]'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-look-method]'));
    var state = { method: 'all', season: 'all' };

    function update() {
      cards.forEach(function (card) {
        var methodMatch = state.method === 'all' || card.dataset.lookMethod === state.method;
        var seasonMatch = state.season === 'all' || card.dataset.lookSeason === state.season;
        card.hidden = !(methodMatch && seasonMatch);
      });

      filters.forEach(function (filter) {
        var active = state[filter.dataset.lookFilter] === filter.dataset.lookValue;
        filter.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    filters.forEach(function (filter) {
      filter.addEventListener('click', function () {
        state[filter.dataset.lookFilter] = filter.dataset.lookValue;
        update();
      });
    });

    update();
  }

  function initAll() {
    document.querySelectorAll('[data-hunting-look]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-hunting-look]'));
  });
})();
